import Vue from 'vue'

import EnumSelect from '@/components/EnumSelect.vue'
import AppInput from '@/components/AppInput.vue'
import AppFormTextInputItn from '@/components/AppFormTextInputItn.vue'

Vue.component('EnumSelect', EnumSelect)
Vue.component('AppInput', AppInput)
Vue.component('AppFormTextInputItn', AppFormTextInputItn)
